import AppBar from "@material-ui/core/AppBar";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Menu from "@material-ui/icons/Menu";
import logo from "assets/images/small-logo.png";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import Close from "@material-ui/icons/Close";
import styles from "./headerStyle.js";
import HeaderLinks from "./HeaderLinks.js";

const useStyles = makeStyles(styles);

export default function Header(props) {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const classes = useStyles();
  React.useEffect(() => {
    if (props.changeColorOnScroll) {
      window.addEventListener("scroll", headerColorChange);
    }
    return function cleanup() {
      if (props.changeColorOnScroll) {
        window.removeEventListener("scroll", headerColorChange);
      }
    };
  });
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const closeDrawer = () => {
    setMobileOpen(false);
  };
  const headerColorChange = () => {
    const { color, changeColorOnScroll } = props;

    const windowsScrollTop = window.pageYOffset;
    if (windowsScrollTop > 155) {
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes.scrolled);
    } else {
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes.scrolled);
      if (
        document.body
          .getElementsByTagName("header")[0]
          .classList.contains("sleep")
      ) {
        document.body
          .getElementsByTagName("header")[0]
          .classList.remove("sleep");
        document.body
          .getElementsByTagName("header")[0]
          .classList.remove(classes.sleep);
      }
    }

    if (windowsScrollTop > 220) {
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[changeColorOnScroll.color]);
      document.body.getElementsByTagName("header")[0].classList.add("awake");
    } else {
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[changeColorOnScroll.color]);
      if (
        document.body
          .getElementsByTagName("header")[0]
          .classList.contains("awake")
      ) {
        document.body.getElementsByTagName("header")[0].classList.add("sleep");
        document.body
          .getElementsByTagName("header")[0]
          .classList.add(classes.sleep);
        document.body
          .getElementsByTagName("header")[0]
          .classList.remove("awake");
      }
    }
  };
  const { color, links, brand, fixed, absolute } = props;
  const appBarClasses = classNames({
    [classes.appBar]: true,
    [classes[color]]: color,
    [classes.absolute]: false,
    [classes.fixed]: fixed,
  });
  return (
    <AppBar className={appBarClasses}>
      <Toolbar
        className={
          classes.container + " " + classes.headerMobile + " borderMobile"
        }
      >
        <Link to="/" className={classes.logoLink} onClick={closeDrawer}>
          <img
            src={logo}
            alt="Paddelhub  Logo"
            className={classes.logo + " logoNavBar"}
          />
        </Link>
        <Hidden smDown implementation="css" className={classes.hidden}>
          <div className={classes.collapse}>
            <HeaderLinks dropdownHoverColor="info" closeDrawer={closeDrawer} />
          </div>
        </Hidden>
        <Hidden mdUp>
          <IconButton aria-label="open drawer" onClick={handleDrawerToggle}>
            <Menu />
          </IconButton>
        </Hidden>
      </Toolbar>
      <Hidden mdUp implementation="js">
        <Drawer
          variant="temporary"
          anchor={"top"}
          open={mobileOpen}
          classes={{
            paper: classes.drawerPaper,
          }}
          onClose={handleDrawerToggle}
        >
          <div className={classes.drawerContainer}>
            <div className={classes.mobileNavExpandedHeader}>
              <Link to="/" className={classes.logoLink} onClick={closeDrawer}>
                <img
                  src={logo}
                  alt="Grey Matter Logo"
                  className={classes.logoMobile}
                />
              </Link>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={closeDrawer}
                className={classes.closeButtonDrawer}
              >
                <Close />
              </IconButton>
            </div>
            <div className={classes.appResponsive}>
              {
                <HeaderLinks
                  dropdownHoverColor="info"
                  closeDrawer={closeDrawer}
                />
              }
            </div>
          </div>
        </Drawer>
      </Hidden>
    </AppBar>
  );
}

Header.defaultProp = {
  color: "white",
};

Header.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "transparent",
    "white",
    "rose",
    "dark",
  ]),
  brand: PropTypes.string,
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
  // this will cause the sidebar to change the color from
  // props.color (see above) to changeColorOnScroll.color
  // when the window.pageYOffset is heigher or equal to
  // changeColorOnScroll.height and then when it is smaller than
  // changeColorOnScroll.height change it back to
  // props.color (see above)
  changeColorOnScroll: PropTypes.shape({
    height: PropTypes.number,
    color: PropTypes.oneOf([
      "primary",
      "info",
      "success",
      "warning",
      "danger",
      "transparent",
      "white",
      "rose",
      "dark",
    ]),
  }),
};
